import { assignmentsTableColumns } from '../config';
import { AssignmentsFilter } from '../models';
import { useMemo } from 'react';
import { Table } from '@/components';
import { useAssignments, useAssignmentsPagination } from '../hooks';
import { useSortableData } from '@/hooks';
import { IconButton} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Edit as EditIcon } from '@mui/icons-material';

import styles from './AssignmentsTable.module.css';
type AssignmentsTableProps = {
  assignmentsFilter?: AssignmentsFilter;
};

const AssignmentsTable = ({ assignmentsFilter }: AssignmentsTableProps) => {
  const columns = useMemo(() => assignmentsTableColumns, []);
  const navigate = useNavigate();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useAssignmentsPagination();

  const { assignments, isAssignmentsLoading, totalItems, totalPages } =
    useAssignments({
      paginated: {
        page: currentPage,
        pageSize: pageSize,
      },
      filters: assignmentsFilter,
    });

  const { sortedData, selectedSort, handleSort } = useSortableData({
    data: assignments,
    currentPage: currentPage,
  });

  const renderActions = (rowData: Record<string, any>) => (
    <IconButton onClick={() => navigate(`/inventory/assignments/${rowData.id}/edit`)}>
      <EditIcon />
    </IconButton>
  );

  return (
    <div className={styles.content}>
      {assignments?.length > 0 ? (
        <Table
          columns={columns}
          data={sortedData}
          selectedSort={selectedSort}
          handleSort={handleSort}
          isLoading={isAssignmentsLoading}
          pagination={{
            totalItems,
            totalPages,
            currentPage,
            rowsPerPage: pageSize,
            onPageChange: handlePageChange,
            onRowsPerPageChange: handlePageSizeChange,
          }}
          renderActions={renderActions}
        />
      ) : (
        'No hay asignaciones pendientes'
      )}
    </div>
  );
};

export default AssignmentsTable;
